export default __webpack_public_path__ + "static/media/side_right.c314b885.png";